import { render, staticRenderFns } from "./FilterOrderStatuses.vue?vue&type=template&id=064aa0fc&scoped=true&lang=pug&"
import script from "./FilterOrderStatuses.vue?vue&type=script&lang=js&"
export * from "./FilterOrderStatuses.vue?vue&type=script&lang=js&"
import style0 from "./FilterOrderStatuses.vue?vue&type=style&index=0&id=064aa0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064aa0fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VIcon,VMenu,VSpacer})
